import { GET_VEHICLE_VIDEO_LIST } from '@/services/api/trackvideo/video'
import { client } from '@/services/apolloclient'
import Vue from 'vue'

export const state = {
    fleets: [],
    loadingFleets: true,
    fleetSelection: [],
    fleetClose: {},
    fleetOpen: {},
    cameraProps: {},
    isVideoProps: {},
    isInVideoProps: {},
    isVideoFullscreenProps: {
        isLoading: false,
        isVideoError: false,
        isVideoStopped: false,
        isPlay: true,
        isMuted: false,
        onLoadingTimeout: null,
        retry: 0
    }
}

export const getters = {
    fleetsListFilter: (state) => search => {
        if (!search) {
            return state.fleets || []
        }

        return state.fleets.filter(fleet =>
            fleet.vehicle.licensePlate.toLowerCase().match(search.toLowerCase()) ||
            (fleet.vehicle.driver1 ? fleet.vehicle.driver1.fullname.toLowerCase().match(search.toLowerCase()) : null)
        )
    },
    fleetsList: (state) => state.fleets || [],
}

export const actions = {
    async requestFleets({ commit }, payload) {
        await client.query({
            query: GET_VEHICLE_VIDEO_LIST,
            variables: payload.filter,
            fetchPolicy: 'no-cache',
        }).then((response) => {
            if (response.data.vehicleVideoTrackers.isSuccessful) {

                var vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers;
                vehicles.forEach(function (item) {
                    item.selected = false;
                })

                commit('setFleets', vehicles)
            }
        })
    },
}

export const mutations = {
    ORDER_BY(state, payload) {
        if (payload.objName == 'licensePlate') {
            if (payload.order === 'asc') {
                state.fleets = state.fleets.sort((a, b) => (a.vehicle[payload.objName] > b.vehicle[payload.objName]) ? 1 : ((b.vehicle[payload.objName] > a.vehicle[payload.objName]) ? -1 : 0))
            } else {
                state.fleets = state.fleets.sort((a, b) => (b.vehicle[payload.objName] > a.vehicle[payload.objName]) ? 1 : ((a.vehicle[payload.objName] > b.vehicle[payload.objName]) ? -1 : 0))
            }
        } else {
            if (payload.order === 'asc') {
                state.fleets = state.fleets.sort((a, b) => (a[payload.objName] > b[payload.objName]) ? 1 : ((b[payload.objName] > a[payload.objName]) ? -1 : 0))
            } else {
                state.fleets = state.fleets.sort((a, b) => (b[payload.objName] > a[payload.objName]) ? 1 : ((a[payload.objName] > b[payload.objName]) ? -1 : 0))
            }
        }
    },
    setFleets(state, payload) {
        state.fleets = payload
    },
    selectFleet(state, payload) {
        if (state.fleetSelection.includes(payload)) return;

        if (state.fleetSelection.length >= 3) {
            Vue.set(state.isVideoProps, `video${payload.vehicleId}`, undefined);
            Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, undefined);
            Vue.set(state.cameraProps, `video${payload.vehicleId}`, undefined);

            state.fleetClose = state.fleetSelection[0];
            state.fleetSelection.splice(0, 1);
        }

        Vue.set(state.isVideoProps, `video${payload.vehicleId}`, {
            isLoading: false,
            isVideoError: false,
            isVideoStopped: false,
            isPlay: true,
            isMuted: false,
            onLoadingTimeout: null,
            src: `https://rtmp.mceasy.id/0/${payload.vehicle.imei}.m3u8`,
            retry: 0,
        })
        Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, {
            isLoading: false,
            isVideoError: false,
            isVideoStopped: false,
            isPlay: true,
            isMuted: false,
            onLoadingTimeout: null,
            src: `https://rtmp.mceasy.id/1/${payload.vehicle.imei}.m3u8`,
            retry: 0,
        })
        Vue.set(state.cameraProps, `video${payload.vehicleId}`, 'INOUT');

        state.fleetOpen = payload;
        state.fleetSelection.push(payload);
    },
    loadingFleets(state, payload) {
        state.loadingFleets = payload
    },
    removeFleet(state, payload) {
        state.fleetOpen = null;

        Vue.set(state.isVideoProps, `video${payload.vehicleId}`, undefined);
        Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, undefined);
        Vue.set(state.cameraProps, `video${payload.vehicleId}`, undefined);

        state.fleetSelection.splice(payload.index, 1);
    },
    clearFleet(state) {
        state.fleetOpen = null;

        Vue.set(state, `isVideoProps`, {});
        Vue.set(state, `isInVideoProps`, {});
        Vue.set(state, `cameraProps`, {});
        Vue.set(state, `fleetSelection`, []);
    },
    setVideoError(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].isVideoError = payload.error;
    },
    setInVideoError(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].isVideoError = payload.error;
    },
    setVideoStopped(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].isVideoStopped = payload.isStop;
    },
    setInVideoStopped(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].isVideoStopped = payload.isStop;
    },
    setPlay(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].isPlay = payload.isPlay;
    },
    setInPlay(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].isPlay = payload.isPlay;
    },
    setMuted(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].isMuted = payload.isMuted;
    },
    setInMuted(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].isMuted = payload.isMuted;
    },
    setRetry(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].retry = payload.retry;
    },
    setInRetry(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].retry = payload.retry;
    },
    setLoading(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].isLoading = payload.isLoading;
    },
    setInLoading(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].isLoading = payload.isLoading;
    },
    setInSrc(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].src = payload.src;
    },

    setCamera(state, payload) {
        state.cameraProps[`video${payload.vehicleId}`] = payload.camera;
    },

    setVideoFullscreenProp(state, payload) {
        state.isVideoFullscreenProps[payload.props] = payload.state;
    },

    setOnLoadingState(state, payload) {
        state.isVideoProps[`video${payload.vehicleId}`].onLoadingTimeout = payload.state;
    },
    setInOnLoadingState(state, payload) {
        state.isInVideoProps[`video${payload.vehicleId}`].onLoadingTimeout = payload.state;
    },

}